import { useEffect, useRef, useState } from 'react';

/**
 * Whether an element has come near the screen (within `margin`), for drawing what's in it only then: a long page of
 * card pictures loads as you scroll rather than all at once. Once near, it stays drawn.
 *
 * @returns {[object, boolean]} a ref for the element, and whether it has been near
 */
export default function useNearView(margin = '800px') {
  const ref = useRef(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || near) {
      return undefined;
    }
    const watcher = new IntersectionObserver(([entry]) => entry.isIntersecting && setNear(true), { rootMargin: margin });
    watcher.observe(element);
    return () => watcher.disconnect();
  }, [near, margin]);

  return [ref, near];
}
